import NarBar from "../cards/navBar";
import Footer from "../cards/footer";
import FabIcon from "../../utils/floatingFab";
import ScrollToTop from "../../utils/scrollToTop";

const Layout = () => {
    return (
        <>
            <ScrollToTop />
            <NarBar />

            <Footer />
            <FabIcon />
        </>
    );
};

export default Layout;
